// Inkfly Photo Booth - Mock Data
import imirrorImg from '../assets/images/imirror.jpeg';
import airboothImg from '../assets/images/airbooth.jpg';
import retroBoothImg from '../assets/images/retro_booth.png';
import photoRoomImg from '../assets/images/photo_room.jpeg';
import stripPhotoBoothImg from '../assets/images/strip_photo_booth.jpeg';
import magazineImg from '../assets/images/magazine.jpeg';
import vogueBoothImg from '../assets/images/vogue_booth.jpeg';
import gifBoothImg from '../assets/images/gif_booth.jpeg';
import arPhotoBoothImg from '../assets/images/ar_photo_booth.jpg';
import glambotImg from '../assets/images/glambot.jpeg';
import timeFreezeImg from '../assets/images/time_freeze.jpg';
import lightPaintingImg from '../assets/images/light_painting.jpeg';
import caricatureBoothImg from '../assets/images/caricature_booth.jpeg';
import wordCloudImg from '../assets/images/word_cloud.jpg';
import wobbleHeadImg from '../assets/images/wobble_head.jpg';
import mrGrapherImg from '../assets/images/mr_grapher.jpeg';
import photoMosaicImg from '../assets/images/airbooth.jpg'; // Fallback for missing asset

import tafeLogo from '../assets/logos/tafe.jpg';
import cognizantLogo from '../assets/logos/cognizant.jpg';
import indianOilLogo from '../assets/logos/indianoil.png';
import hitachiLogo from '../assets/logos/hitachi.jpg';
import leelaPalaceLogo from '../assets/logos/leela.png';
import amazonLogo from '../assets/logos/amazon.png';
import shellLogo from '../assets/logos/shell.png';
import microsoftLogo from '../assets/logos/microsoft.png';
import worldBankLogo from '../assets/logos/worldbank.png';

export const BRAND = {
  name: "Inkfly Photo Booth",
  tagline: "India's Pioneer Photo Booth Company Since 2012",
  subTagline: "Chennai's first. Trusted across India. Creating iconic photo experiences for events, brands & celebrations.",
  phone: "+91 9841433422",
  phone2: "+91 9952075664",
  email: "Print@inkfly.in",
  whatsapp: "919841433422",
  address: "Chennai, Tamil Nadu, India",
  instagram: "https://www.instagram.com/inkflyphotobooth/",
  youtube: "https://www.youtube.com/@inkflyphotobooth/shorts",
  linkedin: "https://www.linkedin.com/company/inkfly-photobooth/",
  photoboothGuruUrl: "https://www.photoboothguru.in"
};

export const STATS = [
  { number: "13+", label: "Years of Innovation" },
  { number: "5000+", label: "Events Executed" },
  { number: "Pan-India", label: "Presence" },
  { number: "Premium", label: "AI-Powered Experiences" }
];

export const PRODUCTS = {
  coreBooths: [
    {
      id: "imirror",
      name: "iMIRROR Photo Booth",
      description: "The iMIRROR Photo Booth is where luxury meets technology. Designed to impress, this full-length interactive mirror engages guests with touch animations, voice guidance, and stunning photo outputs. Perfect for weddings, corporate events, mall activations, and brand launches.",
      highlights: [
        "Full-length interactive mirror",
        "Touch & gesture-based experience",
        "Instant high-quality photo prints & digital sharing",
        "Custom branding, frames & animations",
        "Ideal for premium and high-footfall events"
      ],
      category: "Core Photo Booths",
      useCases: ["Corporate Events", "Weddings", "Brand Activations"],
      image: imirrorImg
    },
    {
      id: "airbooth",
      name: "AirBooth",
      description: "The AirBooth is built for speed, scale, and seamless engagement. Designed to handle large crowds effortlessly, it delivers instant prints, GIFs, and digital content without compromising quality. Sleek, compact, and powerful.",
      highlights: [
        "Fast processing for high guest volumes",
        "Instant prints, GIFs & boomerangs",
        "Minimal footprint, maximum impact",
        "Easy setup & portability",
        "Customizable overlays and branding"
      ],
      category: "Core Photo Booths",
      useCases: ["Corporate Events", "Family Gatherings", "Promotional Campaigns"],
      image: airboothImg
    },
    {
      id: "retro-booth",
      name: "Retro Booth",
      description: "Bring nostalgia back in style with the Retro Booth. Inspired by classic photo booths, this setup blends vintage aesthetics with modern camera technology. Perfect for themed events, weddings, and brands that want a timeless look with contemporary performance.",
      highlights: [
        "Vintage-inspired design",
        "Modern DSLR-quality photos",
        "Instant prints & digital sharing",
        "Custom props and layouts",
        "Aesthetic appeal that stands out"
      ],
      category: "Core Photo Booths",
      useCases: ["Weddings", "Themed Events", "Celebrations"],
      image: retroBoothImg
    },
    {
      id: "photo-room",
      name: "Photo Room",
      description: "The Photo Room offers a private, immersive photo booth experience with full-size enclosure. Guests step into a dedicated space with professional lighting and backdrops, creating studio-quality photos in a fun, intimate setting.",
      highlights: [
        "Full-size enclosed booth",
        "Professional studio lighting",
        "Privacy curtains for comfort",
        "Multiple backdrop options",
        "Perfect for weddings & premium events"
      ],
      category: "Core Photo Booths",
      useCases: ["Weddings", "Premium Events", "Corporate Galas"],
      image: photoRoomImg
    },
    {
      id: "strip-photo-booth",
      name: "Strip Photo Booth",
      description: "The Strip Photo Booth captures classic photo strip memories just like the iconic mall booths! Multiple shots in one session create a fun, shareable strip format that guests love to keep as souvenirs.",
      highlights: [
        "Classic photo strip format",
        "Multiple shots per session",
        "Instant strip prints",
        "Custom templates & branding",
        "Perfect keepsake for guests"
      ],
      category: "Core Photo Booths",
      useCases: ["Weddings", "Parties", "Mall Events"],
      image: stripPhotoBoothImg
    },
    {
      id: "magazine-booth",
      name: "Magazine Cover Booth",
      description: "The Magazine Cover Booth lets guests become cover stars! This unique experience creates professional magazine-style covers with custom layouts, making every guest feel like a celebrity. Perfect for brand activations, product launches, and premium events.",
      highlights: [
        "Professional magazine-style photos",
        "Custom cover layouts & branding",
        "Instant prints & digital sharing",
        "High-quality studio lighting",
        "Perfect for PR events & brand activations"
      ],
      category: "Core Photo Booths",
      useCases: ["Brand Activations", "Product Launches", "Corporate Events"],
      image: magazineImg
    },
    {
      id: "vogue-booth",
      name: "Vogue Booth",
      description: "The Vogue Booth turns guests into fashion icons! Inspired by high-fashion editorial shoots, this booth captures stunning, magazine-worthy photos with professional lighting and dynamic poses perfect for social media.",
      highlights: [
        "High-fashion photo capture",
        "Professional studio lighting",
        "Dynamic pose guidance",
        "Instant prints & digital sharing",
        "Perfect for fashion & lifestyle events"
      ],
      category: "Core Photo Booths",
      useCases: ["Fashion Events", "Brand Launches", "Social Media Activations"],
      image: vogueBoothImg
    },
    {
      id: "gif-booth",
      name: "GIF Booth",
      description: "Short, fun, and highly shareable—the GIF Booth captures moments that move. Guests can create looping GIFs and boomerangs that are instantly shareable on social platforms, making it a favorite for youth-centric and brand engagement events.",
      highlights: [
        "Animated GIFs & boomerangs",
        "Instant digital sharing",
        "Minimal setup, high engagement",
        "Custom branding & overlays",
        "Perfect for social media activations"
      ],
      category: "Core Photo Booths",
      useCases: ["Youth Events", "Brand Activations", "Social Media Campaigns"],
      image: gifBoothImg
    },
    {
      id: "ar-photo-booth",
      name: "AR Photo Booth",
      description: "The AR Photo Booth brings augmented reality magic to your events! Guests can interact with virtual elements, filters, and 3D objects in real-time, creating unique and shareable content that stands out on social media.",
      highlights: [
        "Augmented reality experiences",
        "Interactive virtual elements",
        "Real-time 3D effects & filters",
        "Instant digital sharing",
        "Perfect for tech-forward events"
      ],
      category: "Core Photo Booths",
      useCases: ["Tech Events", "Brand Activations", "Product Launches"],
      image: arPhotoBoothImg
    }
  ],
  premiumExperiences: [
    {
      id: "glambot",
      name: "Glambot",
      description: "The Glambot brings Hollywood to your event! This robotic arm camera captures stunning slow-motion videos with dramatic lighting effects, making every guest feel like a red carpet celebrity. Perfect for high-profile events and brand launches.",
      highlights: [
        "Robotic arm camera technology",
        "Cinematic slow-motion capture",
        "Dramatic lighting effects",
        "Red carpet experience",
        "Perfect for celebrity & VIP events"
      ],
      category: "Premium Experiences",
      useCases: ["Red Carpet Events", "Brand Launches", "Celebrity Events"],
      image: glambotImg
    },
    {
      id: "time-freeze",
      name: "Time Freeze Booth",
      description: "The Time Freeze Booth captures moments that feel impossible—freezing guests mid-air or mid-action using multiple synchronized cameras. The result is a dramatic, cinematic visual that stops people in their tracks.",
      highlights: [
        "Multi-camera time-freeze effect",
        "High-impact visual output",
        "Perfect for brand launches & mall activations",
        "Creates viral-worthy content",
        "Premium, next-level engagement experience"
      ],
      category: "Premium Experiences",
      useCases: ["Brand Activations", "Product Launches", "VIP Events"],
      image: timeFreezeImg
    },
    {
      id: "light-painting-booth",
      name: "Light Painting Booth",
      description: "The Light Painting Booth creates mesmerizing long-exposure light art photos. Guests wave LED wands to paint with light, creating stunning, one-of-a-kind artistic images that glow with creativity.",
      highlights: [
        "Long-exposure light photography",
        "LED light wands included",
        "Unique artistic output",
        "Instant prints & digital sharing",
        "Perfect for creative events"
      ],
      category: "Premium Experiences",
      useCases: ["Art Events", "Brand Activations", "Corporate Events"],
      image: lightPaintingImg
    },
    {
      id: "caricature-booth",
      name: "Caricature Booth",
      description: "The Caricature Booth uses AI-powered technology to transform guest photos into fun, artistic caricatures in real-time. A unique and entertaining experience that creates memorable keepsakes for every guest.",
      highlights: [
        "AI-powered caricature generation",
        "Real-time artistic transformation",
        "Multiple art styles available",
        "Instant prints & digital sharing",
        "Fun & engaging for all ages"
      ],
      category: "Premium Experiences",
      useCases: ["Corporate Events", "Family Events", "Brand Activations"],
      image: caricatureBoothImg
    },
    {
      id: "word-cloud-booth",
      name: "Word Cloud Booth",
      description: "The Word Cloud Booth creates stunning visual word art from guest photos. Using AI technology, it transforms portraits into beautiful word cloud compositions that make for unique and personalized keepsakes.",
      highlights: [
        "AI-powered word cloud generation",
        "Personalized text compositions",
        "Unique artistic output",
        "Instant prints & digital sharing",
        "Perfect for corporate messaging"
      ],
      category: "Premium Experiences",
      useCases: ["Corporate Events", "Conferences", "Team Building"],
      image: wordCloudImg
    },
    {
      id: "wobble-head-booth",
      name: "Wobble Head Booth",
      description: "The Wobble Head Booth creates fun, personalized bobblehead-style figurines from guest photos. A unique takeaway that guests will treasure, perfect for corporate events and special celebrations.",
      highlights: [
        "Personalized bobblehead creation",
        "Fun & memorable keepsakes",
        "Quick turnaround time",
        "Custom branding options",
        "Perfect conversation starter"
      ],
      category: "Premium Experiences",
      useCases: ["Corporate Events", "Celebrations", "Brand Activations"],
      image: wobbleHeadImg
    },
    {
      id: "photo-mosaic",
      name: "Photo Mosaic Wall",
      description: "The Photo Mosaic Wall transforms individual guest photos into one powerful visual masterpiece. As photos are captured, they come together to reveal a larger branded image—making it a powerful tool for corporate events, team building, and brand activations.",
      highlights: [
        "Live photo-to-mosaic experience",
        "Strong visual brand impact",
        "High audience participation",
        "Perfect for corporate & large-scale events",
        "Final reveal creates a lasting impression"
      ],
      category: "Premium Experiences",
      useCases: ["Conferences", "Team Building", "Large Celebrations"],
      image: photoMosaicImg
    },
    {
      id: "mr-grapher",
      name: "Mr. Grapher",
      description: "Meet Mr. Grapher—your roaming photo entertainer. This interactive photographer-on-wheels moves through the crowd, capturing candid moments and instantly delivering prints or digital photos, ensuring no guest is left out.",
      highlights: [
        "Mobile & interactive photo experience",
        "Perfect for crowd engagement",
        "Instant prints & sharing",
        "Fun, approachable design",
        "Ideal for exhibitions and large venues"
      ],
      category: "Premium Experiences",
      useCases: ["Exhibitions", "Large Venues", "Roaming Events"],
      image: mrGrapherImg
    }
  ]
};

export const GALLERY_CATEGORIES = [
  "All",
  "Photo Booths"
];

export const GALLERY_IMAGES = [
  { id: 1, category: "Photo Booths", image: imirrorImg, title: "iMIRROR Photo Booth" },
  { id: 2, category: "Photo Booths", image: airboothImg, title: "AirBooth" },
  { id: 3, category: "Photo Booths", image: retroBoothImg, title: "Retro Booth" },
  { id: 4, category: "Photo Booths", image: glambotImg, title: "Glambot" },
  { id: 5, category: "Photo Booths", image: timeFreezeImg, title: "Time Freeze Booth" },
  { id: 6, category: "Photo Booths", image: caricatureBoothImg, title: "Caricature Booth" },
  { id: 7, category: "Photo Booths", image: magazineImg, title: "Magazine Cover Booth" },
  { id: 8, category: "Photo Booths", image: vogueBoothImg, title: "Vogue Booth" },
  { id: 9, category: "Photo Booths", image: gifBoothImg, title: "GIF Booth" },
  { id: 10, category: "Photo Booths", image: arPhotoBoothImg, title: "AR Photo Booth" },
  { id: 11, category: "Photo Booths", image: photoRoomImg, title: "Photo Room" },
  { id: 12, category: "Photo Booths", image: stripPhotoBoothImg, title: "Strip Photo Booth" },
  { id: 13, category: "Photo Booths", image: lightPaintingImg, title: "Light Painting Booth" },
  { id: 14, category: "Photo Booths", image: mrGrapherImg, title: "Mr. Grapher" },
  { id: 15, category: "Photo Booths", image: wordCloudImg, title: "Word Cloud Booth" },
  { id: 16, category: "Photo Booths", image: wobbleHeadImg, title: "Wobble Head Booth" }
];

export const WHY_INKFLY = [
  {
    title: "Pioneer Since 2012",
    description: "Chennai's first photo booth company, setting industry standards for over 13 years."
  },
  {
    title: "5000+ Events Delivered",
    description: "Proven reliability with thousands of successful events across India."
  },
  {
    title: "Premium Products",
    description: "iMIRROR, AirBooth, Retro Booth & Vintage Booth - quality that stands out."
  },
  {
    title: "High-End Experiences",
    description: "Glambot, Time Freeze Booth, Caricature Booth & Photo Mosaic Wall for extraordinary events."
  },
  {
    title: "Trusted by Top Brands",
    description: "Partnered with top Corporates, Agencies, wedding planners and Event planners."
  },
  {
    title: "Pan-India Execution",
    description: "Professional support and flawless execution across all major cities."
  }
];

export const CLIENT_LOGOS = [
  { name: "Tafe", id: 1, logo: tafeLogo },
  { name: "Amazon", id: 2, logo: amazonLogo },
  { name: "Shell", id: 3, logo: shellLogo },
  { name: "Cognizant", id: 4, logo: cognizantLogo },
  { name: "Indian Oil", id: 5, logo: indianOilLogo },
  { name: "Hitachi", id: 6, logo: hitachiLogo },
  { name: "Microsoft", id: 7, logo: microsoftLogo },
  { name: "World Bank", id: 8, logo: worldBankLogo },
  { name: "Leela Palace", id: 9, logo: leelaPalaceLogo }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Khushi Jain",
    role: "",
    quote: "We've done 2 events with you now and both of them were perfect. The quality of your work, your team members and their patience and the style of working was really commendable. Thank you so much for all your patience and support. Looking forward to working with you again very soon. :)",
    rating: 5
  },
  {
    id: 2,
    name: "Subhaashini Sekar",
    role: "",
    quote: "We absolutely loved Inkfly booth and their services...we opted for Airbooth for our wedding reception and oh boy!, It was a huge hit and people loved seeing the hardcopy collage pictures with the wedding template created... Would definitely suggest them to make your event lively♥️",
    rating: 5
  },
  {
    id: 3,
    name: "Rashmita Nayak",
    role: "",
    quote: "Absolutely loved the physical mosaic wall photobooth! The service, attention to detail, and overall experience were fantastic. It added a unique and interactive touch to our event. Highly recommend!",
    rating: 5
  }
];

export const MILESTONES = [
  { year: "2012", title: "The Beginning", desc: "Instant Prints for Marathons and Large Gatherings" },
  { year: "2013", title: "First Automated Booth", desc: "Chennai's First Automated Photobooth" },
  { year: "2014", title: "In-House Innovation", desc: "Made in house mirror booth" },
  { year: "2020", title: "Bullet Freeze Pioneer", desc: "India's First Seamless Bullet Freeze Photobooth" },
  { year: "2020", title: "360 Spin Launch", desc: "South India's first 360 Spin with Premium features" },
  { year: "2023", title: "New Product Line", desc: "India's first ZooooM, Top Spin, Vogue Light Booth" },
  { year: "2023", title: "Glambot Arrives", desc: "South India's first Glambot" },
  { year: "2024", title: "Premium Upgrade", desc: "Premium iMIRROR & Vintage Booth" },
  { year: "2025", title: "Latest Innovations", desc: "Mr. Grapher & Retro Booth" }
];

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Products", path: "/products" },
  { name: "Gallery", path: "/gallery" },
  { name: "Blog", path: "/blog" },
  { name: "Why Inkfly", path: "/why-inkfly" },
  { name: "Contact", path: "/contact" }
];

export const BLOG_POSTS = [
  {
    id: "why-photobooth-for-events",
    title: "Why Photo Booth for Events?",
    excerpt: "Discover how photo booths have become an essential element for creating memorable experiences at weddings, corporate events, and celebrations.",
    image: timeFreezeImg,
    date: "December 25, 2025",
    author: "Inkfly Team",
    content: `
## The Magic of Photo Booths at Events

In today's experience-driven world, events are no longer just about gathering people together—they're about creating lasting memories. Photo booths have emerged as one of the most popular and effective ways to enhance any event, from intimate weddings to large-scale corporate functions.

### 1. Instant Entertainment for All Ages

Photo booths provide instant entertainment that appeals to guests of all ages. Whether it's grandparents striking a pose or children having fun with props, everyone can participate and enjoy. The interactive nature of photo booths breaks the ice and gets people mingling, creating a lively atmosphere.

### 2. Tangible Memories to Take Home

In an age of digital everything, there's something special about holding a physical photograph. Photo booth prints serve as instant keepsakes that guests can take home, serving as a lasting reminder of your special event. These prints often find their way onto refrigerators and photo albums, keeping your event in guests' minds long after it's over.

### 3. Social Media Gold

Modern photo booths come equipped with instant sharing capabilities. Guests can immediately post their photos to social media platforms, extending the reach of your event far beyond the venue. For corporate events and brand activations, this organic social media exposure is invaluable.

### 4. Guest Book Alternative

Photo booth strips make excellent additions to guest books. Many couples and event planners now use photo booth pictures as a creative alternative to traditional sign-in books, creating a visual memoir of all the guests who attended.

### 5. Brand Engagement for Corporate Events

For corporate events and brand activations, photo booths offer unique branding opportunities. Custom overlays, backdrops, and print templates can be designed to incorporate company logos and messaging, turning every photo into a branded touchpoint.

### 6. Creates Shared Experiences

Photo booths encourage group photos and shared experiences. They bring people together in a fun, casual setting, helping to create connections and memories that might not happen otherwise.

### The Bottom Line

Whether you're planning a wedding, corporate event, birthday party, or brand activation, a photo booth adds an element of fun and engagement that guests truly appreciate. It's not just about taking pictures—it's about creating experiences and memories that last a lifetime.

Ready to add a photo booth to your next event? Contact Inkfly Photo Booth today to explore our range of premium photo booth experiences!
    `
  },
  {
    id: "why-choose-inkfly-photobooth",
    title: "Why Choose Inkfly Photo Booth?",
    excerpt: "Learn what makes Inkfly Photo Booth India's leading photo booth company and why top brands and event planners trust us for their events.",
    image: imirrorImg,
    date: "December 25, 2025",
    author: "Inkfly Team",
    content: `
## Why Inkfly Photo Booth Stands Out

When it comes to photo booth experiences in India, Inkfly Photo Booth has been setting the standard since 2012. As Chennai's first and India's leading photo booth company, we've had the privilege of serving over 5,000 events across the nation. Here's why top brands, event planners, and couples choose Inkfly for their special moments.

### 1. Pioneer Experience Since 2012

We didn't just join the photo booth industry—we pioneered it in South India. With over 13 years of experience, we've seen trends come and go, and we've consistently stayed ahead of the curve. Our deep understanding of the Indian market and event culture sets us apart.

### 2. Premium Quality Equipment

At Inkfly, we don't compromise on quality. Our booths feature:
- Professional DSLR cameras for crystal-clear photos
- Studio-grade lighting for flattering shots
- High-speed dye-sublimation printers for instant, smudge-proof prints
- Custom-built enclosures designed for durability and aesthetics

### 3. Widest Range of Photo Booth Experiences

From classic iMIRROR booths to cutting-edge Glambot and Time Freeze experiences, we offer the most comprehensive range of photo booth solutions in India:
- **iMIRROR Photo Booth** - Interactive full-length mirror experience
- **AirBooth** - Compact and powerful for high-volume events
- **Glambot** - Hollywood-style robotic arm camera
- **Time Freeze Booth** - Multi-camera bullet-time effect
- **Caricature Booth** - AI-powered artistic transformations
- And many more!

### 4. Customization at Its Best

Every event is unique, and we treat it that way. We offer:
- Custom overlay designs matching your event theme
- Branded backdrops and props
- Personalized print templates
- Custom animations and user interfaces

### 5. Professional Team & Support

Our trained operators ensure seamless execution at every event. We handle:
- Professional setup and breakdown
- On-site technical support
- Guest assistance and engagement
- Real-time troubleshooting

### 6. Pan-India Operations

While we're headquartered in Chennai, our operations span across India. We've successfully executed events in major cities including Mumbai, Delhi, Bangalore, Hyderabad, and beyond.

### 7. Trusted by Leading Brands

Our client list includes Fortune 500 companies, leading brands, celebrity events, and thousands of weddings. When the biggest names trust Inkfly, you know you're in good hands.

### 8. Innovation at Core

We're constantly evolving. From being the first to introduce automated photo booths in Chennai to pioneering AI-powered experiences, innovation is in our DNA. We don't follow trends—we create them.

### 9. End-to-End Solutions

Beyond just photo booths, we offer:
- Digital galleries for easy photo access
- Social media integration
- Analytics and reporting for corporate clients
- Post-event support and deliverables

### Ready to Experience the Inkfly Difference?

Join the thousands of satisfied clients who have trusted Inkfly Photo Booth to make their events memorable. Whether it's a wedding, corporate event, brand activation, or celebration, we have the perfect photo booth solution for you.

Contact us today for a free consultation and let's create something extraordinary together!
    `
  }
];
